import { CCol, CContainer, CRow } from "@coreui/react";
import React, { useEffect } from "react";
import "../../assets/css/resume.css";
import imgs from "../../assets/images/Award/Appreciation-ico.png";
import Recommendations from "../../assets/images/Award/Recommendation.jpg";
import Footer from "../footer/footer";
import Navbars from "../navbar/navbar";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga4";

export default function Recommendation() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
  return (
    <div>
      <Helmet>
        <title>Mohanraj - Recommendation Letter</title>
        <link rel="joinimagine" href="https://www.joinimagine.com" />
        <meta
          name="description"
          content="Backed by a European employer's recommendation, my skills and dedication shine in delivering exceptional results."
        />
      </Helmet>
      <Navbars />
      <div className="resumers certificates recommend">
        <div>
          <CContainer>
            <br />
            <br />
            <br />
            <div className="tops">
              <CRow>
                <CCol>
                  <div>
                    <h1>
                      Endorsement
                      <br />
                      by Imagine
                    </h1>
                  </div>
                </CCol>
                <CCol>
                  <center>
                    <img
                      src={imgs}
                      alt="mn"
                      data-aos="zoom-in"
                      data-aos-duration="3000"
                    />
                  </center>
                </CCol>
              </CRow>
            </div>
            <div className="pdf pb-4">
              <center>
                <img
                  src={Recommendations}
                  alt="mn"
                  data-aos="zoom-in"
                  data-aos-duration="3000"
                />
              </center>
            </div>
          </CContainer>
        </div>
        <div className="foot">
          <Footer />
        </div>
      </div>
    </div>
  );
}
